import { AuthGuard } from '../../shared/guard/auth.guard';
import { Injectable } from '@angular/core';
import {AngularFireDatabase, AngularFireList,  AngularFireObject} from '@angular/fire/database';
import * as firebase from 'firebase';
import {Business} from '../../models/business';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { ActionItems } from 'src/app/models/actionItems';
import {  map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FireActionItemService {
  actionItemsRef: AngularFireList<any>; // Reference to Assessment data list, its an Observable
  actionItemRef: AngularFireObject<any>; // Reference to assessment object
  public database = firebase.database();
  public ref;
  public actRoute: ActivatedRoute;
  public router: Router;
  public auth: AuthGuard;
  public dbStore = firebase.firestore();
  private aItemPath = 'user-actionItem';



   
  sustainibleActionItemRef : AngularFirestoreCollection<ActionItems>=null;
  sustainibleActionItemRefNew: AngularFirestoreCollection;
 
  constructor (private db: AngularFireDatabase, private guard: AuthGuard,private dbstore: AngularFirestore ) {
    this.sustainibleActionItemRef = dbstore.collection(this.aItemPath);
    this.sustainibleActionItemRefNew  = this.dbstore.collection('users').doc(`${this.guard.uid}`).collection('actionItems');
   }

   
   // Firestore Assessment Create the Assessment in FireStore
   createSustainibleActionItem ( actionItem:ActionItems):void {
     this.sustainibleActionItemRefNew.add({...actionItem});
       
   }

   updateSustainibleActionItem ( id:string, value:any): Promise <void> {
    return this.sustainibleActionItemRef.doc(id).update(value);
   }

   deleteSustainibleActionItemDoc (id:string) : Promise <void> {
    return this.sustainibleActionItemRefNew.doc(id).delete();
   }

   readSustainibleActionItemList ():AngularFirestoreCollection {
   // return this.sustainibleActionItemRef;
     return this.sustainibleActionItemRefNew;
   }


 /*  deleteSustainibleActionItem (id:string, index: any) {
     debugger
       this.sustainibleActionItemRef.doc(id).update({
        //['actionItemArray.' + index]:  firebase.firestore.FieldValue.arrayRemove('actionItemName')
        actionItemArray:  firebase.firestore.FieldValue.arrayRemove('actionItemName')
      })
      }
      
        updateSustainibleActionItem ( id:string, value:any): Promise <void> {
    return this.sustainibleActionItemRef.doc(id).update(value);
   }

      
      */

   deleteAllSustainibleActionItem () {
     this.sustainibleActionItemRef.get().subscribe(
       querySnapshot => {
         querySnapshot.forEach((doc) =>{
           doc.ref.delete();
         });
       },
       error=>{
         console.log('Error deleting all documents: ', error);
       });
   }

    /**
   * Create assessment in firestore
   * @param actionItem - data about actionItem assessment
   * @returns 
   */


  // create assessment
 /* async createActionItem(actionItem: ActionItems): Promise<string>  {
    //const key = this.database.ref('/users').push().key; // is this what's causing it? assementref.push..its pushing the key under the uid and on the database
    const adminCode = (await this.dbStore.collection(this.aItemPath).doc(this.guard.uid).get())?.data()?.adminCode;
    const res = await this.sustainibleActionItemRef.add({
         adminCode: adminCode || null,//problem
         userID: this.guard.uid,//problem
         actionItemArray: actionItem.actionItemArray,
      });

      return res.id;
  
    }*/

     /*async createActionItemCollection(): Promise<string>  {
      debugger
      const res = await this.sustainibleActionItemRef.add({
           adminCode: null,//problem
           userID: this.guard.uid,//problem
           actionItemArray: null,
        }) 
        return res.id;
      }
    //shuold create action item in a new collection vs under 'user'account
      createActionItemCollection2()  {
        debugger
       this.dbstore.collection(this.aItemPath).doc(`${this.guard.uid}`).set({
             adminCode: null,//problem
             userID: this.guard.uid,//problem
             actionItemsCollection: this.dbstore.collection('users').doc(this.guard.uid).collection('actionItems').doc('getStarted').set({//gives users an action item collection
                actionItemName: 'Get Started'
    }); 
          }) 
        }*/
      


 
  actionItemID: any;

  ReadActionItem() {//Unused function
    debugger
  this.dbstore.collection(this.aItemPath, ref => ref.where('userID', '==', this.guard.uid))
    .get().toPromise().then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
            // doc.data() is never undefined for query doc snapshots
            console.log(doc.id, " => ", doc.data());
        });
    })
    .catch(function(error) {
        console.log("Error getting documents: ", error);

  })
};


async getActionItemInfo(){
  const userAcions = await this.dbstore.collection('user-actionItem', ref => ref.where('userID', '==', this.guard.uid)).get().toPromise();
  userAcions.forEach((doc) => {
    this.actionItemID = doc.data();
    console.log(this.actionItemID)
  })
  
}


  UpdateActionItem(actionItem: ActionItems) {
    this.actionItemRef.update({
      //actionItemArray: actionItem.actionItemArray,
    });
  }

  DeleteActionItem() {
    this.actionItemRef = this.db.object('users/');
    this.actionItemRef.remove();
  }

}